import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-239618e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proportion-cell" }
const _hoisted_2 = { class: "proportion-bar" }
const _hoisted_3 = { class: "proportion-text" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import type { CategoryProportionItem } from '../../types'
import type { TableOpt } from '@/components/cmTable/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'category-proportion',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {

const { t, locale } = useI18n()

const props = __props

const effectiveData = computed<CategoryProportionItem[]>(() => {
  void locale.value
  if (props.data !== undefined) {
    return props.data
  }
  return [
    { rank: 1, category: t('overviewZone.demoCategoryBusiness'), proportion: 90 },
    { rank: 2, category: t('overviewZone.demoCategoryInfra'), proportion: 50 },
    { rank: 3, category: t('overviewZone.demoCategoryEntertainment'), proportion: 30 },
    { rank: 4, category: t('overviewZone.demoCategoryMalicious'), proportion: 20 },
    { rank: 5, category: t('overviewZone.demoCategoryMining'), proportion: 10 },
  ]
})
function getRankClass(rank: number): string {
  if (rank <= 3) {
    return `rank-${rank}`
  }
  return 'rank-inactive'
}
const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    showSearch: false,
    showForm: false,
    showActionBar: false,
    showRightToolbar: false,
    hiddenPageTool: true,
    headerStyle: {
      transparent: true,
      showBorder: false
    },
    height: '100%',
    columns: [
      { prop: 'rank', label: t('overviewZone.catRankCol'), width: 60, columnOpt: { align: 'center' } },
      { prop: 'category', label: t('overviewZone.catDomainType'), width: 120 },
      { prop: 'proportion', label: t('overviewZone.catProportion'), minWidth: 200 }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmTable, {
    tableOpt: tableOpt.value,
    data: effectiveData.value
  }, {
    rank: _withCtx((rankSlotProps) => [
      _createElementVNode("div", {
        class: _normalizeClass(["rank-badge", getRankClass((rankSlotProps as any).value)])
      }, _toDisplayString((rankSlotProps as any).value), 3)
    ]),
    proportion: _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "proportion-fill",
            style: _normalizeStyle({ width: `${row.proportion}%` })
          }, null, 4)
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(row.proportion) + "%", 1)
      ])
    ]),
    _: 1
  }, 8, ["tableOpt", "data"]))
}
}

})